import React from 'react'
import Modal from '../Modal'
import { api } from '../../utils/api'
import { useAuth } from '../../context/AuthContext'
import toast from 'react-hot-toast'
import { useLoading } from '../../context/LoadingContext'

const ModalConfirm = ({
  isOpen,
  setIsOpen,
  onClose,
  armaSelecionadaAcervo,
  setOpenModalChangeStatus,
  getData,
  getExpiredDocuments,
}) => {
  const { user } = useAuth()
  const { startLoading, stopLoading } = useLoading()

  const onSubmit = async () => {
    startLoading()
    try {
      const response = await fetch(`${api}acervoPessoal/changeStatus`, {
        method: 'POST',
        body: JSON.stringify({
          id: armaSelecionadaAcervo.pessoaArmaID,
          status: armaSelecionadaAcervo.status === '1' ? '0' : '1',
          banco: user.clube.banco,
          clubeID: user.clube.clubeID,
          pessoaID: user.pessoa.pessoaID,
          usuarioID: user.pessoa.usuarioID,
          pendencia: armaSelecionadaAcervo.pendencia,
          numeroSerie: armaSelecionadaAcervo.numeroSerie,
        }),
      })
      const res = await response.json()

      if (!response.ok || !res.success) {
        throw new Error(res.error || 'Não foi possível alterar a arma.')
      }

      // A mensagem vem do servidor: ele reavalia a pendencia e pode inativar
      // em vez de excluir, para nao orfanar lancamentos ja feitos com a arma.
      toast.success(res.message || 'Arma atualizada com sucesso!')
      await Promise.all([getData(), getExpiredDocuments()])
      onClose()
    } catch (error) {
      console.log(error)
      toast.error(
        error.message ||
          `Erro ao ${
          !armaSelecionadaAcervo.pendencia
            ? 'excluir'
            : armaSelecionadaAcervo.status === '1'
            ? 'inativar'
            : 'ativar'
        } arma!`
      )
    } finally {
      stopLoading()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSave={onSubmit}
      onClose={() => setOpenModalChangeStatus(false)}
      onCloseIcon={() => setOpenModalChangeStatus(false)}
      colorBtn1={
        !armaSelecionadaAcervo.pendencia || armaSelecionadaAcervo.status === '1'
          ? 'danger'
          : 'secondary'
      }
      titleBnt1={`${!armaSelecionadaAcervo.pendencia ? 'Excluir' : 'Salvar'}`}
      bnt1Type="button"
      title={
        !armaSelecionadaAcervo.pendencia
          ? 'Excluir arma'
          : armaSelecionadaAcervo.status === '1'
          ? 'Inativar arma'
          : 'Ativar arma'
      }
      size="sm"
      zIndex="z-30"
    >
      <h1 className="text-lg ">
        Deseja
        {!armaSelecionadaAcervo.pendencia
          ? ' excluir'
          : armaSelecionadaAcervo.status === '1'
          ? ' inativar'
          : ' ativar'}{' '}
        esta arma?
      </h1>
    </Modal>
  )
}

export default ModalConfirm
